import {useMemo} from "react";
import {Annotation} from "../types/Types";
import {useFileAnnotations} from "./useJsonLoader";


export function useAnnotationMap() {
  const annotation = useFileAnnotations();

  return useMemo(() => {
    const map = new Map<number, Annotation>();
    for (const ann of annotation || []) {
      for (const id of ann.entrez) {
        map.set(id, ann);
      }
    }
    return map;
  }, [annotation]);
}
